export const PERIOD_SELECTION_ACTIONS = {
  SET_INITIAL_STATE: 'PERIOD_SELECTION:SET_INITIAL_STATE',
  SET_PERIOD_START: 'PERIOD_SELECTION:SET_DETALIZATION_PERIOD_START',
  SET_PERIOD_END: 'PERIOD_SELECTION:SET_DETALIZATION_PERIOD_END',
  SET_IS_PERIOD_DATA_VALID: 'PERIOD_SELECTION:SET_IS_DETALIZATION_PERIOD_DATA_VALID',
  SET_CALENDAR_VIEW: 'PERIOD_SELECTION:SET_CALENDAR_VIEW',
};

export const MAX_REPORT_PERIOD_IN_DAYS = 31;
